function convertTimezone (date) {
  if (!date || Object.prototype.toString.apply(date).slice(8, -1) !== 'Date') return
  const offset = date.getTimezoneOffset()
  return new Date(date.getTime() + (offset * 60 * 1000))
}

export default convertTimezone
